import React from 'react'
import axios from 'axios'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import toastr from '@/lib/notifications'

// Same reasons the customer dashboard offers when cancelling a service.
const REASONS = [
  'I was just looking around',
  'Its a duplicate',
  'This is too expensive',
  "I've found a competing service",
  "I don't need this anymore",
  'Other',
]

class CancelCustomerOrder extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      reason: '',
      other_reason: '',
      saving: false,
    }

    this.onReasonChange = this.onReasonChange.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
  }

  onReasonChange(value) {
    this.setState({ reason: value, other_reason: '' })
  }

  onConfirm() {
    if (!this.state.reason || (this.state.reason === 'Other' && !this.state.other_reason.trim())) {
      toastr.error('Please select a reason.')
      return
    }

    this.setState({ saving: true })

    axios.post(`/api/sales/enquiries/${this.props.enquiryId}/service_cancellations`, {
      service_id: this.props.serviceId,
      reason: this.state.reason,
      other_reason: this.state.other_reason,
    })
      .then(() => {
        toastr.success('Order cancelled.')
        this.props.onCancelled()
      })
      .catch((error) => {
        this.setState({ saving: false })
        const message = (error && error.response && error.response.data && error.response.data.custom_error_message) || 'Failed to cancel the order.'
        toastr.error(message)
      })
  }

  render() {
    return (
      <div role="form">
        <div className="mb-4 flex flex-wrap items-center">
          <Label className="w-full md:w-1/3 px-3">Reason</Label>
          <div className="w-full md:w-2/3 px-3">
            <Select value={this.state.reason || undefined} onValueChange={this.onReasonChange}>
              <SelectTrigger className="w-full"><SelectValue placeholder="Select a reason" /></SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {REASONS.map((reason) => (
                    <SelectItem key={reason} value={reason}>{reason}</SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </div>

        {this.state.reason === 'Other' && (
          <div className="mb-4 flex flex-wrap">
            <Label className="w-full md:w-1/3 px-3 pt-2">Details</Label>
            <div className="w-full md:w-2/3 px-3">
              <Textarea
                value={this.state.other_reason}
                onChange={(e) => this.setState({ other_reason: e.target.value })}
                placeholder="Please specify the reason..."
                rows={3}
              />
            </div>
          </div>
        )}

        <div className="mt-6 flex justify-end gap-2">
          <Button variant="outline" onClick={this.props.onClose} disabled={this.state.saving}>
            Keep Order
          </Button>
          <Button variant="destructive" onClick={this.onConfirm} disabled={this.state.saving}>
            {this.state.saving ? 'Cancelling...' : 'Cancel Order'}
          </Button>
        </div>
      </div>
    )
  }
}

export default CancelCustomerOrder
